import React from "react";
import ReactDOM from "react-dom/client"; // 'react-dom' yerine 'react-dom/client' import edin
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
